module.exports = __webpack_public_path__ + "img/Ramsey_Center_Front_View_500x200.456d8577.jpg";